import BuzonSugerenciaPublicComponent from '@/components/rrhh/BuzonSugerenciaPublicComponent'
import BuzonSugerenciasFormComponent from '@/components/rrhh/buzon_sugerencias/BuzonSugerenciasFormComponent'
import ConstanciasLaboralesComponent from '@/components/rrhh/constancias_laborales/ConstanciasLaboralesComponent'
import ContratosEmpleadoComponent from '@/components/rrhh/contratos_empleados/ContratosEmpleadoComponent'
import EncuestasMainComponent from '@/components/rrhh/encuestas_informes/EncuestasMainComponent'

export default [{
    path: '/rrhh/buzon-sugerencias/public',
    name: 'rrhh-buzon-suegerencias-public',
    component: BuzonSugerenciaPublicComponent,
    meta: {
        requiresAuth: false
    }
}, {
    path: '/rrhh/buzon-sugerencias/',
    name: 'rrhh-buzon-suegerencias',
    component: BuzonSugerenciasFormComponent,
    meta: {
        requiresAuth: true
    }
},
{
    path: '/rrhh/constancias-laborales',
    name: 'rrhh-constancias-laborales',
    component: ConstanciasLaboralesComponent,
    meta: {
        requiresAuth: true
    }
},
{
    path: '/rrhh/contratos/',
    name: 'rrhh-contratos-empleado',
    component: ContratosEmpleadoComponent,
    meta: {
    }
},
{
    path: '/rrhh/encuestas-informes/',
    name: 'rrhh-encuestas-informes',
    component: EncuestasMainComponent,
    meta: {
        requiresAuth: true
    }
},
]